class Articulo{
    constructor(id, descripcion, precio_compra, precio_venta, stock, stock_minimo, marca_id, familia_id, alicuota_iva_id, vista_impresion){
        this.id = id;
        this.descripcion = descripcion;
        this.precio_compra = precio_compra;
        this.precio_venta = precio_venta;
        this.stock = stock;
        this.stock_minimo = stock_minimo;
        this.marca_id = marca_id;
        this.familia_id = familia_id;
        this.alicuota_iva_id = alicuota_iva_id;
        this.vista_impresion = vista_impresion
    }
}
export default Articulo;
